<template>
    <div class="card-colour-picker d-inline-block">
        <i v-show="show_close" class="fa fa-close closeButton" @click="closeButton()"></i>
        <div class="vue_color_swatch" :style="{'background-color':color}" @click="showPicker"></div>
        <vue-color v-show="show_picker" class="" :preset-colors="presetColors" :disable-alpha="true" :value="value" @input="setColor($event)"></vue-color>
        <input type="hidden" :name="name" :ref="name" :value="color" />
    </div>
</template>

<script>
    import VueColor from 'vue-color/src/components/Sketch.vue';

    export default {
        mounted () {
            document.addEventListener('click', this.hidePicker)
          },
        beforeDestroy () {
            document.removeEventListener('click',this.hidePicker)
        },
        components: {
           'vue-color' : VueColor,
        },
        props: {
            value: {
                default: '#ffffff'
            },
            name,
            swatches:{
      
            },
        },
        data(){
            return {
                color: this.value,
                show_picker: false,
                show_close: false,
                presetColors: this.swatches,
            }
        },
        methods: {
            closeButton: function(){
                this.show_picker = false;
                this.show_close = false;
            },
            showPicker: function(){
                this.show_close = true;
                this.show_picker = true;
            },
            hidePicker: function(e){
                if (!this.$el.contains(e.target)) {
                    this.show_picker = false;
                    this.show_close = false;
                }
            },
            setColor: function(color){
                this.color = color.hex;
                this.$emit('change', color.hex);
            }
        }

      }
</script>

<style type="text/css">
    .card-colour-picker{
        position: relative;
    }
    .card-colour-picker .vc-sketch{
        position: relative;
        top: -50px;
        left: 70px;
    }
    .card-colour-picker .closeButton{
        position: absolute;
        left: 280px;
        top: -10px;
        z-index: 9;
        cursor: pointer;
        background: #fff;
        border: 1px solid #ccc;
        border-radius: 50%;
        display: block;
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 10px;
        padding: 4px;
        z-index: 1010;
    }
    .card-colour-picker .closeButton::before{
        width: 16px;
        height: 16px;
        line-height: 1;
        text-align: center;
        display: block;
        position: relative;
        left: -3px;
        top: -2px;
    }
    .card-colour-picker .vc-sketch{
        z-index: 999;
    }
</style>